import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg, fmt } from "@/lib/api";
import { Modal } from "@/components/ui-bits";

const PauseModal = ({ inv, maxWeeks, asClient, onClose, onDone }) => {
  const [weeks, setWeeks] = useState(2);
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const resumes = new Date(Date.now() + weeks * 7 * 86400000);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { const r = await api.post(`/invoices/${inv.id}/pause`, { weeks, reason: reason || null }); toast.success(`Membership paused until ${fmt(r.data.pausedUntil, { day: "numeric", month: "short" })}`); onDone(r.data); onClose(); }
    catch (ex) { toast.error(errMsg(ex)); } finally { setBusy(false); }
  };
  return (
    <Modal title="PAUSE MEMBERSHIP" sub={`${inv.packName} · no charges while paused, resumes automatically`} onClose={onClose} testId="pause-modal">
      <form onSubmit={submit}>
        <label>Pause for</label>
        <div className="tabs" data-testid="pause-weeks">
          {Array.from({ length: maxWeeks }, (_, i) => i + 1).map((w) => <button type="button" key={w} className={weeks === w ? "on" : ""} onClick={() => setWeeks(w)} data-testid={`pause-weeks-${w}`}>{w} wk</button>)}
        </div>
        <div className="ss" data-testid="pause-resumes">Resumes {fmt(resumes.toISOString(), { weekday: "short", day: "numeric", month: "short" })} · the next monthly charge moves to then.</div>
        <label>{asClient ? "Let your coach know why (optional)" : "Note (optional)"}</label>
        <input value={reason} onChange={(e) => setReason(e.target.value)} maxLength={120} placeholder={asClient ? "Holiday in Bali 🌴" : "Client travelling"} data-testid="pause-reason-input" />
        <div className="mfoot"><button type="button" className="btn g" onClick={onClose}>Cancel</button><button className="btn" disabled={busy} data-testid="pause-confirm-button">{busy ? "Pausing…" : `Pause ${weeks} week${weeks > 1 ? "s" : ""}`}</button></div>
      </form>
    </Modal>
  );
};

export const PauseChip = ({ inv }) => (inv.paused ? <span className="chip warn" data-testid={`invoice-paused-${inv.id}`}><span className="dot" />paused until {fmt(inv.pausedUntil, { day: "numeric", month: "short" })}</span> : null);

export const MembershipPause = ({ inv, maxWeeks = 8, asClient = false, onChange }) => {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  if (inv.status !== "paid" || !inv.subscriptionId) return null;
  const resume = async () => {
    setBusy(true);
    try { const r = await api.post(`/invoices/${inv.id}/resume`); toast.success("Membership resumed — welcome back"); onChange(r.data); }
    catch (ex) { toast.error(errMsg(ex)); } finally { setBusy(false); }
  };
  return (
    <>
      {inv.paused
        ? <button className="btn sm" disabled={busy} onClick={resume} data-testid={`resume-membership-${inv.id}`}>{busy ? "Resuming…" : "Resume now"}</button>
        : <button className="btn sm g" onClick={() => setOpen(true)} data-testid={`pause-membership-${inv.id}`}>Pause</button>}
      {open && <PauseModal inv={inv} maxWeeks={maxWeeks} asClient={asClient} onClose={() => setOpen(false)} onDone={onChange} />}
    </>
  );
};
